'use client';
import { forwardRef, useId } from 'react';
import { Box } from '@wanteddev/wds-engine';
import WithInteraction from '../with-interaction/index.mjs';
import { buttonStyle } from './style.mjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var Button = forwardRef(
  ({
    as,
    variant: originVariant,
    disabled = false,
    disableInteraction = false,
    fullWidth = false,
    color = "primary",
    iconOnly,
    leftIcon,
    rightIcon,
    size = "medium",
    children,
    xs,
    sm,
    md,
    lg,
    xl,
    ...props
  }, ref) => {
    const id = useId();
    const variant = originVariant || "solid";
    const interactionColor = color === "primary" && variant === "outlined" ? "palette.primary.normal" : "palette.label.normal";
    const getInteractionVariant = () => {
      switch (variant) {
        case "outlined":
          return color === "primary" ? "normal" : "light";
        case "solid":
          return color === "primary" ? "strong" : "normal";
      }
    };
    return /* @__PURE__ */ jsx(
      WithInteraction,
      {
        color: interactionColor,
        variant: getInteractionVariant(),
        disabled: disableInteraction || disabled,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            as: as || "button",
            "aria-labelledby": iconOnly ? void 0 : id,
            ref,
            disabled,
            "aria-disabled": disabled,
            type: "button",
            ...props,
            sx: [
              buttonStyle({
                variant,
                iconOnly,
                size,
                fullWidth,
                color,
                xs,
                sm,
                md,
                lg,
                xl
              }),
              props.sx
            ],
            children: iconOnly ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
              Boolean(leftIcon) && leftIcon,
              /* @__PURE__ */ jsx("span", { id, children }),
              Boolean(rightIcon) && rightIcon
            ] })
          }
        )
      }
    );
  }
);
Button.displayName = "Button";
var button_default = Button;

export { button_default as default };
